export default "__VITE_ASSET__Cr5e3W_3__"